import http from './_http'

const webshell = {
  get: (id) => http.get(`api/v3/webshell/${id}`),
  list: (m) => http.post(`api/v3/webshell/search`, m),
  add: (m) => http.post(`api/v3/webshell/`, m),
  update: (m) => http.put(`api/v3/webshell`, m),
  update_bulk: (selectId, m) => http.put(`api/v3/webshell/bulk/${selectId}`, m),
  delete: (id) => http.delete(`api/v3/webshell/${id}`),
}

const wsfinder = {
  webshell
}
export default wsfinder
export { webshell }